// Polyfill for regex lookbehind support in Safari 14.1
// This must be imported before any code that uses casbin

// Check if lookbehind is supported
let lookbehindSupported = false;
try {
  // eslint-disable-next-line no-new
  new RegExp('(?<=a)b');
  lookbehindSupported = true;
} catch {
  lookbehindSupported = false;
}

if (!lookbehindSupported) {
  // Lookbehind not supported, need to patch RegExp
  const OriginalRegExp = window.RegExp;

  // Create a new RegExp constructor
  const PatchedRegExp = function (pattern: string | RegExp, flags?: string): RegExp {
    if (typeof pattern === 'string') {
      // Remove lookbehind assertions as a workaround
      // Note: This may affect casbin's functionality slightly
      pattern = pattern
        .replace(/\(\?<=/g, '(?:') // Convert positive lookbehind to non-capturing group
        .replace(/\(\?<!/g, '(?!'); // Convert negative lookbehind to negative lookahead
    }
    return new OriginalRegExp(pattern, flags);
  };

  // Copy static properties and methods
  Object.setPrototypeOf(PatchedRegExp, OriginalRegExp);
  Object.getOwnPropertyNames(OriginalRegExp).forEach((prop) => {
    if (prop !== 'prototype' && prop !== 'constructor') {
      try {
        (PatchedRegExp as any)[prop] = (OriginalRegExp as any)[prop];
      } catch {
        // Some properties might be read-only
      }
    }
  });

  // Set the prototype
  PatchedRegExp.prototype = OriginalRegExp.prototype;

  // Override the global RegExp
  (window as any).RegExp = PatchedRegExp;
}

export {};
